import { useState, useEffect } from 'react';
import { Settings, Check, X } from 'lucide-react';

export default function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowConsent(true);
    }

    const handleOpen = () => setShowConsent(true);
    window.addEventListener('openCookieConsent', handleOpen);
    return () => window.removeEventListener('openCookieConsent', handleOpen);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-white dark:bg-zinc-900 rounded-3xl shadow-2xl border border-zinc-200 dark:border-zinc-800 p-6 md:p-8 pointer-events-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <h3 className="text-xl font-bold mb-2 text-zinc-900 dark:text-zinc-50 flex items-center gap-2">
            <Settings className="w-5 h-5 text-blue-600 dark:text-blue-500" />
            Záleží nám na vašom súkromí
          </h3>
          <p className="text-zinc-600 dark:text-zinc-400 font-medium text-sm max-w-2xl">
            Tento web používa súbory cookies na poskytovanie služieb, prispôsobenie reklám a analýzu návštevnosti. 
            Kliknutím na tlačidlo "Prijať všetko" súhlasíte s používaním všetkých cookies. Viac informácií nájdete v{' '}
            <a href="/ochrana-osobnych-udajov" className="text-blue-600 dark:text-blue-500 hover:underline">Zásadách ochrany osobných údajov</a>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
          <button 
            onClick={handleDecline}
            className="px-6 py-3 rounded-xl font-bold bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-colors flex items-center justify-center gap-2"
          >
            <X className="w-4 h-4" /> Iba nevyhnutné
          </button>
          <button 
            onClick={handleAccept}
            className="px-6 py-3 rounded-xl font-bold bg-blue-500 text-white hover:bg-blue-600 transition-colors flex items-center justify-center gap-2 shadow-lg shadow-blue-500/20"
          >
            <Check className="w-4 h-4" /> Prijať všetko
          </button>
        </div>
      </div>
    </div>
  );
}
